import { render, staticRenderFns } from "./dmConfirmModal.vue?vue&type=template&id=6b8b3b64&"
import script from "./dmConfirmModal.vue?vue&type=script&lang=js&"
export * from "./dmConfirmModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports